<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Multiselect from "@vueform/multiselect";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader, Multiselect
  },
  data() {

    return {
      title: "Ordem de Serviço Saída (WMS)",
      items: [
        {
          text: "Estoque",
          href: "/"
        },
        {
          text: "Ordem de Serviço Saída (WMS)",
          active: true
        }
      ],
      totalizadores: [],
      usersDataList: {},
      dataList: null,
      totalList: 0,
      updating: false,
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,
      showAssocRoma: false,
      showSeparaTodos: false,
      showSelecionaConf: false,
      userSelected: null,
      idRomaneioAssoc: 0,
      dtListPesqRoma: null,
      codProdutoFiltrar: null,
      idsOrdensSepTodos: null,

      showModalTransp: false,
      transpCriarRomaneio: null,
      loadingTransp: false,
      dtListPesqTransp: [],
      tipoMapaSeparacao: null,
      opcoesTipoMapaSeparacao: [
        { value: "ped",  text: 'Por Pedido' },
        { value: "prod",  text: 'Por Produto' },
      ],
      showModalImprimirSeparacao: false
    };
  },

  created() {
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted wms-saida-list_0')
    this.atualizaDataList()
  },

  methods: {
    escolherTipoMapaSeparacao(){
      this.showModalImprimirSeparacao = true
    },

    imprimirMapaSeparacao(){
      console.log("imprimirMapaSeparacao")
      console.log(`tipoMapaSeparacao: ${this.tipoMapaSeparacao}`)

      const ids = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(ids)
      console.log(ids.length)

      if(this.tipoMapaSeparacao === null){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Selecionar tipo de mapa de separação.",
          showConfirmButton: false,
          timer: 1500
        })

        return
      }

      if (ids.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum movimento foi selecionado, favor selecionar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        /* Ajustando a url */
        let url = ""
        switch(this.tipoMapaSeparacao){
          case "ped":
            url = "geramapaseparacaoped"
            break
          case "prod":
            url = "geramapaseparacaoprod"
            break
        }
        console.log(url)

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Gerar mapa separação (Ordens " + ids + ")",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.updating = true
            api.get(`${getBaseUrl()}api/${url}`,{
              params: {
                'ids': ids,
              },
              responseType: 'blob'
            }).then(response => {
              console.log('then axios geramapaseparacao')
              console.log(response.data)

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Relatorio_separacao_' + this.tipoMapaSeparacao + '.pdf');
              document.body.appendChild(fileLink);
              fileLink.click();

              this.updating = false
            })
          }
        }).then(() => {
          this.showModalImprimirSeparacao = false
        })
      }
    },

    indicaTranspAssocRomaneio(){
      this.showModalTransp = true
      this.showAssocRoma = false
    },

    pesqTransp(evt){
      console.log('pesqTransp')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true

        api.get(`${getBaseUrl()}api/transpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.dtListPesqTransp = res.data
        })
      }
    },

    confirmarTransp(){
      console.log('confirmarTransp')
      this.showModalTransp = false

      this.confirmarAssocRomaNovo2()
    },

    redirectWmsOsAvulso(){
      console.log('redirect conferência avulsa...')
      this.$router.push('/wmsos/saidaeditarnova/0')
    },

    filtrarProduto() {

      Swal.fire({
        position: "center",
        icon: "question",
        input: 'text',
        inputPlaceholder: 'Código de Produto',
        title: "Filtrar Ordens de Serviço",
        text: "Apenas contendo produtos com código:",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          console.log(result)
          console.log(result.value)
          this.codProdutoFiltrar = result.value
          this.atualizaDataList()
        }
      })
    },

    selecionaConferente() {
      console.log('selecionaConferente');

      //Buscando lista de users para indicação
      api.get(`${getBaseUrl()}api/userSep`).then(response => {
        console.log('then usuarios')
        // console.log(response.data)

        this.usersDataList = response.data

        if(this.usersDataList && this.usersDataList.length > 1){
          this.userSelected = this.usersDataList[0].id

          this.showSelecionaConf = true

        } else if (this.usersDataList &&  this.usersDataList.length === 1) {
          this.userSelected = this.usersDataList[0].id

          this.iniciarSeparacao();
        }
      })
    },

    iniciarSeparacao(){
      console.log('iniciarSeparacao')
      this.showSelecionaConf = false

      const userData = this.usersDataList.find((value) => value.id === this.userSelected);
      // console.log('userData : ' , userData)

      console.log('gerarSeparacao')

      // console.log('this.dataGrid.getSelectedItems()')
      // console.log(this.dataGrid.getSelectedRowsData())

      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      console.log(idsAtualizar.length)
      if (idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum movimento foi selecionado, favor selecionar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Gerar Ordem de Separação (Ordens " + idsAtualizar + ") Conferente: " + userData.name ,
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.updating = true
            console.log('vai Atualizar')
            api.get(`${getBaseUrl()}api/wmsosinisep`,{
              params: {
                'ids': idsAtualizar,
                'userconfer': userData
              }
            }).then(response => {
              console.log('response.data')
              console.log(response)
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento(s) processado(s) com sucesso!",
                text: response.data[0],
                showConfirmButton: false,
                timer: 3500
              }).then(() => {
                /* Reativar se quiser direcionar para os
                let idData = response.data[1]
                console.log(idData)
                this.$router.push(`/wmsos/saidaeditarnova/${idData}`)
                */

                this.atualizaDataList()
              })
              this.updating = false
            })
          }
        })
      }


    },



    associarRomaneio() {
      console.log('associarRomaneio')
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(idsAtualizar)

      if (idsAtualizar.length === 0) {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar algum movimento antes de associar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.showAssocRoma = true
      }
    },



    separarTodos() {
      console.log('separarTodos')
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      if (idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar algum movimento antes de associar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.idsOrdensSepTodos = idsAtualizar
        this.showSeparaTodos = true
      }
    },

    confirmarAssocRoma(){
      console.log('associarRomaneio')
      // console.log(this.wmsosList)
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()

      console.log('idsAtualizar')
      console.log(idsAtualizar)

      // let idsAssoc = []
      // this.wmsosList.forEach((value) => {
      //   // console.log(value)
      //   if (value.checked === true){
      //     idsAssoc.push(value.id)
      //     // idsAssoc = idsAssoc + value.id.toString()
      //   }
      // })
      // console.log('idsAassociar')
      // console.log(idsAssoc)

      api.post(`${getBaseUrl()}api/wmsromawmsos`, {
        idRoma: this.idRomaneioAssoc,
        idsData: idsAtualizar
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false

      if (res.data[0] === 'success'){
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          const routeData = this.$router.resolve(`/wmsromaneio/editar/` + this.idRomaneioAssoc)
          window.open(routeData.href, '_blank')
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: res.data[1],
          showConfirmButton: false,
          timer: 2500
        })
      }

        this.atualizaDataList()
      })
    },

    confirmarAssocRoma2(){
      console.log('associarRomaneio2')
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar: ' , idsAtualizar)

      api.post(`${getBaseUrl()}api/wmsromamov`, {
        idRoma: this.idRomaneioAssoc,
        idsData: idsAtualizar,
        origem: 'wmsos'
      }).then((res) => {
        console.log('then axios associarRomaneio 2')
        console.log(res.data)

        this.showAssocRoma = false

        if(res.data.success){
          if(res.data.listMovsNaoAssociadas && res.data.listMovsNaoAssociadas.length > 0){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Algumas notas não puderam ser associadas!",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: 'Baixar erros',
              cancelButtonText: 'Ir para romaneio',
            }).then(escolha => {
              if(escolha.isConfirmed){
                // Monta o conteúdo do arquivo
                let conteudo = res.data.listMovsNaoAssociadas
                    .map(item => `Nota Fiscal: ${item.numnf ?? '-'} | ID: ${item.mov_id} | Erro: ${item.error} | Id Romaneio: ${item.wmsroma_id}`)
                    .join('\n'); // Garante a quebra de linha entre mensagens

                // Cria um Blob com os dados em formato de texto
                const blob = new Blob([conteudo], { type: 'text/plain' });

                // Cria um link temporário para download
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'erros_notas.txt';

                // Adiciona ao DOM e clica no link para iniciar o download
                document.body.appendChild(link);
                link.click();

                // Remove o link do DOM após o download
                document.body.removeChild(link);

                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }else{
                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }
            }).then(() => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + this.idRomaneioAssoc)
                window.open(routeData.href, '_blank')
              })
            })
          }else{
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              const routeData = this.$router.resolve(`/wmsromaneio/editar/` + this.idRomaneioAssoc)
              window.open(routeData.href, '_blank')
            })
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 2500
          })
        }

        this.atualizaDataList()
      })
    },


    confirmarSeparaTodos(){
      console.log('confirmarSeparaTodos')
      this.showSeparaTodos = false
      this.updating = true
      let idsAtualizar = []
      this.dataGrid.getSelectedRowsData().forEach((os) => {
        console.log(os.wmsos_id)
        console.log(os.wmsos_status)
        if (os.wmsos_status === 'ES' || os.wmsos_status === 'AB') {
          idsAtualizar.push(os.wmsos_id)
        }
      })
      api.post(`${getBaseUrl()}api/wmsosseptodosmuitos`, {
        idsData: idsAtualizar
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.updating = false
          this.atualizaDataList()
        })
      })
    },


    confirmarAssocRomaNovo(){
      console.log('confirmarAssocRomaNovo')
      // console.log(this.wmsosList)
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      this.updating = true
      api.post(`${getBaseUrl()}api/wmsromawmsosnv`, {
        idsData: idsAtualizar
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showAssocRoma = false
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data[0].id)
          window.open(routeData.href, '_blank')
        })
      })
      this.atualizaDataList()
    },

    confirmarAssocRomaNovo2(){
      console.log('confirmarAssocRomaNovo2')
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      this.updating = true

      api.post(`${getBaseUrl()}api/wmsromaorct`, {
        idsData: idsAtualizar,
        transp: this.transpCriarRomaneio,
        origem: 'wmsos'
      }).then((res) => {
        console.log('then axios confirmarAssocRomaNovo2')
        console.log(res.data)
        this.showAssocRoma = false
        this.updating = false
        this.transpCriarRomaneio = null

        if(res.data.success){
          if(res.data.listMovsNaoAssociadas && res.data.listMovsNaoAssociadas.length > 0){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Algumas notas não puderam ser associadas!",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: 'Baixar erros',
              cancelButtonText: 'Ir para romaneio',
            }).then(escolha => {
              if(escolha.isConfirmed){
                // Monta o conteúdo do arquivo
                let conteudo = res.data.listMovsNaoAssociadas
                    .map(item => `Nota Fiscal: ${item.numnf ?? '-'} | ID: ${item.mov_id} | Erro: ${item.error} | Id Romaneio: ${item.wmsroma_id}`)
                    .join('\n'); // Garante a quebra de linha entre mensagens

                // Cria um Blob com os dados em formato de texto
                const blob = new Blob([conteudo], { type: 'text/plain' });

                // Cria um link temporário para download
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'erros_notas.txt';

                // Adiciona ao DOM e clica no link para iniciar o download
                document.body.appendChild(link);
                link.click();

                // Remove o link do DOM após o download
                document.body.removeChild(link);

                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }else{
                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }
            }).then(() => {
              this.atualizaDataList()
            })
          }else{
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
              window.open(routeData.href, '_blank')
            }).then(() => {
              this.atualizaDataList()
            })
          }
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            this.atualizaDataList()
          })
        }
      })
    },


    pesqRomaneio(evt){
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },


    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Ordens de Serviço Saída: ${dtIniFormated} - ${dtFimFormated}`

      this.totalizadores = this.dataList.totalizadores;
    },


    atualizaDataList(){
      console.log('atualizaDataList_wmsos')
      console.log(this.exibEmit)

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const exibEmit = this.exibEmit
      const exibDest = this.exibDest
      const exibAmbos = this.exibAmbos
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro
      const codProd = this.codProdutoFiltrar

      this.dataList = new CustomStore({
        key: "wmsos_id",
        load: function(loadOptions){

          console.log('exibEmit')
          console.log(exibEmit)

          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'ee': exibEmit,
            'ed': exibDest,
            'ea': exibAmbos,
            'di': di,
            'df': df,
            'cprod': codProd
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/wmsossdlistnva`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            //console.log(`response dataList: ${JSON.stringify(response.data)}`)

            this.totalizadores = response.data[2];

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log('row.data.origem2')
      console.log(row.data.wmsos_origem2)

      let idData = row.key
      if (row.data.wmsos_origem2 === 'romaneio') {
        console.log(idData)
        this.$router.push(`/wmsos/saidaromaeditar/${idData}`)
      } else {
        console.log(idData)
        this.$router.push(`/wmsos/saidaeditarnova/${idData}`)
      }
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "wmsos_status") {
          const valStatus = e.data.wmsos_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'AB':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'SE':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break

          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = null
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }


      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    atualizaPagina() {
      window.location.reload();
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
      this.atualizaPagina()
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return 0.00;
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'AB':
          return 'Não Conferido (AB)'
        case 'ES':
          return 'Em Separação (ES)'
        case 'SE':
          return 'Conferido (SE)'
        case 'CA':
          return 'Cancelado (CA)'
      }
      return 'Não Definido'
    },

  },


};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>

    <div>
      <div class="card-body border-top mb-3">
        <h5 class="text-truncate mb-4">Panorama geral do período Filtrado:</h5>
        <div class="text-center">
          <div class="row">
            <div class="col-6 col-sm-3">
              <div>
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-line-chart text-info"></i>
                </div>

                <p class="text-muted mb-2">Geral</p>
                <h5>{{ this.totalizadores.geral }}</h5>
              </div>
            </div>

            <div class="col-6 col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-check-double text-danger"></i>
                </div>
                <p class="text-muted mb-2">Em Aberto</p>
                <h5>{{ this.totalizadores.emAberto }}</h5>
              </div>
            </div>

            <div class="col-6 col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-check-double text-warning"></i>
                </div>

                <p class="text-muted mb-2">Em Separaçao</p>
                <h5>{{ this.totalizadores.emSeparacao }}</h5>
              </div>
            </div>

            <div class="col-6 col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-check-double text-success"></i>
                </div>

                <p class="text-muted mb-2">Separado</p>
                <h5>{{ this.totalizadores.separado }}</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div>
      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <!--        <DxItem-->
        <!--            location="before"-->
        <!--            widget="dxButton">-->
        <!--          <DxButton-->
        <!--              icon="increaselinespacing"-->
        <!--              hint="Gerar Separação"-->
        <!--              :on-click="gerarSeparacao"/>-->
        <!--        </DxItem>-->

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="insertcolumnleft"
              hint="Associar a Romaneio"
              text="Associar a Romaneio"
              :on-click="associarRomaneio"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Conferir Todos"
              text="Conferir Todos"
              :on-click="separarTodos"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="showpanel"
              hint="Iniciar Separação"
              text="Iniciar Separação"
              :on-click="selecionaConferente"/> <!--iniciarSeparacao-->
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              icon="print"
              hint="Mapa Separação"
              text="Mapa Separação"
              :on-click="escolherTipoMapaSeparacao"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="filter"
              hint="Filtrar Produto"
              :text="codProdutoFiltrar !== null ? codProdutoFiltrar : 'Filtrar Produto'"
              :on-click="filtrarProduto"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="todo"
              hint="Separação avulsa"
              text="Iniciar separação avulsa"
              :on-click="redirectWmsOsAvulso"/>
        </DxItem>

      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strWmsOsSaidaList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping/>


        <DxColumn
            :width="330"
            caption="Ordens"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="wmsos_created_at"
              caption="Criado em"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yy HH:mm:ss"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_updated_at"
              caption="Última Att"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yy HH:mm:ss"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_status"
              caption="Status"
              alignment="center"
              data-type="text"
              :customize-text="nomeStatus"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_id"
              sort-order="desc"
              caption="ID"
              data-type="number"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_conferente"
              caption="Conferente"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_codigo"
              caption="Código"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>
          <DxColumn
              data-field="wmsos_numnf"
              caption="Nota Fiscal"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_wmsroma_id"
              caption="Romaneio"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="codobj"
              caption="Cód. Objeto"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_origem"
              caption="Origem"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="wmsos_origem2"
              caption="Origem"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              :width="110"
              data-field="wmsos_qtd"
              caption="Quant."
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="110"
              data-field="wmsos_qtddisp"
              caption="Quant. Disponivel"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="110"
              data-field="wmsos_qtdlida"
              caption="Quant. Lida"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="110"
              data-field="wmsos_percsep"
              caption="Perc. Separado"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

        </DxColumn>


        <DxColumn
            :width="230"
            caption="Remetente"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="remetnome"
              caption="Nome"
              data-type="text"
              alignment="left"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="remetcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

        </DxColumn>

        <DxColumn
            :width="230"
            caption="Destinatário"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="nome"
              caption="Nome"
              data-type="text"
              alignment="left"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="destcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="destcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="destestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>
        </DxColumn>


        <DxColumn
            :width="230"
            caption="Transportador"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="nometransp"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="transpcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="transpcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="transpestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="true"/>

        </DxColumn>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>

    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal title="Associar a Romaneio"
             size="lg"
             v-model="showAssocRoma"
             centered hide-footer>
      <div class="col-md-12">

        <div class="mb-3">
          <span>Selecionar Romaneio  {{ idRomaneioAssoc }}</span>

          <multiselect id="inputRomaneio"
                       @search-change="pesqRomaneio"
                       v-model="idRomaneioAssoc"
                       placeholder="Pesquisar romaneio"
                       :options="dtListPesqRoma"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.id }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.pessoa_motorista }}</div>
              </div>
            </template>
          </multiselect>

        </div>

        <div class="text-end mt-5">


          <b-button variant="light" @click="showAssocRoma = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>


          <b-button variant="outline-success" class="ms-1" @click="indicaTranspAssocRomaneio">
            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
            Criar e Associar a Novo Romaneio
          </b-button>

          <b-button :disabled="idRomaneioAssoc === 0"
                    type="submit" variant="success" class="ms-1" @click="confirmarAssocRoma2">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>

        </div>
      </div>
    </b-modal>


    <b-modal title="Conferir Todos"
             size="lg"
             v-model="showSeparaTodos"
             centered hide-footer>
      <div class="col-md-12">
        <h5>Confirma conferência de todos os itens das ordens: </h5>
        <h6>{{ idsOrdensSepTodos }}</h6>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showSeparaTodos = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarSeparaTodos()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>



    <b-modal title="Favor selecionar Conferente."
             size="lg"
             v-model="showSelecionaConf"
             centered hide-footer>
      <div class="col-md-12">

        <div class="mb-3">
          <span> ID Conferente Selecionado: {{ userSelected }}</span>

          <b-form-select v-model="userSelected">
            <b-form-select-option :value="null" variant="outline" disabled>Selecione o Conferente</b-form-select-option>
            <b-form-select-option v-for="list in usersDataList" :key="list.id" :value="list.id" >
              {{ list.name }}
            </b-form-select-option>
          </b-form-select>

        </div>

        <div class="text-end mt-5">

          <b-button variant="light" @click="showSelecionaConf = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button :disabled="userSelected === null"
                    type="submit" variant="success" class="ms-1" @click="iniciarSeparacao()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Detalhes Transportadora" v-model="showModalTransp" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Transportadora</span>

          <multiselect id="repres"
                       @search-change="pesqTransp"
                       @select="confirmarTransp"
                       v-model="transpCriarRomaneio"
                       placeholder="Pesquisar transportadora"
                       :options="dtListPesqTransp"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="cnpj">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.cnpj }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingTransp">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalTransp = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarTransp">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Seleção de Mapa de Separação"
             size="md"
             v-model="showModalImprimirSeparacao"
             centered hide-footer>
      <div class="col-md-12">

        <div class="mb-3">
          <!--<span><em>{{ tipoMapaSeparacao }}</em></span>-->

          <b-form-select v-model="tipoMapaSeparacao">
            <b-form-select-option :value="null" variant="outline" disabled>Selecione o tipo de Mapa de Separação</b-form-select-option>
            <b-form-select-option v-for="list in opcoesTipoMapaSeparacao" :key="list.id" :value="list.value" >
              {{ list.text }}
            </b-form-select-option>
          </b-form-select>
        </div>

        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalImprimirSeparacao = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button :disabled="tipoMapaSeparacao === null"
                    type="submit" variant="success" class="ms-1" @click="imprimirMapaSeparacao">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>
